<template lang="pug">
GenericCard.allsales-comm-print-panel(size='40')
  .d-flex.flex-column.px-4.py-4
    .text-large
      | พิมพ์สรุปรายการขายและค่าคอม
    CustomDatePickerSingle.mt-3.mx-auto(
      v-model='selectedDate'
    )
    .mt-2.mx-auto
      SellerPickerDropdown(
        v-model='selectedSeller'
      )=`sellerList`
    //- )

    .d-flex.justify-content-center.mt-3
      button.btn.btn-upa-secondary.px-3(
        @click='downloadPDF'
      )
        i.fa.fa-print.mr-1
        | พิมพ์

      button.btn.btn-upa-secondary.ml-2.px-3(
        @click='downloadXLS'
      )
        i.fa.fa-download.mr-1
        | ดาวโหลดเป็น .xls

  //- hr.m-0.w-100
  //- .d-flex.flex-column
  //-   template(v-if='error')
  //-     .text-center.text-medium.red.p-3
  //-       | {{ error }}
  //-   template(v-else-if='success')
  //-     //- .alert.alert-success
  //-     .text-center.text-medium.p-3
  //-       img.mr-2(src='@/assets/icons/success.svg' width='20px')
  //-       | ดาวโหลดไฟล์สำเร็จ
</template>

<script>
import SellerPickerDropdown from '@/components/_admin/seller-records/SellerPickerDropdown.vue';

// const fileDownload = require('js-file-download');

// ARGS
// const FILE_NAME = 'sales-and-comm-report.pdf';
// const ORDER_STATUSES = [
//   { value: '', text: 'เลือกสถานะรายการขาย' },
//   { value: 'back_order', text: 'back i' },
// ];

export default {
  data() {
    return {

      selectedDate: this.$moment().startOf('day').toDate(),
      selectedSeller: [],

      // error: null,
      // success: false,
    };
  },
  // computed: {
  // },
  methods: {
    urlForPDF() {
      return this.$api.admin.report.salesAndCommReportURL(
        this.selectedSeller ? this.selectedSeller.map(elm => elm.id) : null,
        this.selectedDate,
      );
    },
    urlForXLS() {
      return this.$api.admin.report.salesAndCommExcelURL(
        this.selectedSeller ? this.selectedSeller.map(elm => elm.id) : null,
        this.selectedDate,
      );
    },
    async downloadPDF() {
      const URL = this.urlForPDF();
      console.log(URL);
      window.open(URL);
    },
    async downloadXLS() {
      const URL = this.urlForXLS();
      console.log(URL);
      window.open(URL);
    },
  },
  components: {
    SellerPickerDropdown,
  },
};
</script>

<style lang="scss">
// .line-api-panel {}
</style>
